import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';

export class LocalizeBySchemaBaseValueConverter {
    toView(key, localization) {
        if(!StringHelper.IsNullOrEmpty(key) && ObjectHelper.IsNotNullAndUndefined(localization) && localization.length > 0) {
            let filteredItem = localization.filter((item) => item['key'] == key);
            
            if(ObjectHelper.IsNotNullAndUndefined(filteredItem) && filteredItem.length > 0) {
                return filteredItem[0].value;
            }
        }

        return key;
    }
}